// extracted by mini-css-extract-plugin
export default {"loginBox":"login_loginBox__GL5U4"};